import React from "react";
import { Instagram, MessageCircle, MapPin, PawPrint } from "lucide-react";
import { SITE, waLink } from "../lib/site";

export default function Footer() {
  return (
    <footer
      id="contato"
      className="relative overflow-hidden py-20 text-white bg-[radial-gradient(circle_at_15%_20%,rgba(242,169,0,0.22),transparent_20%),radial-gradient(circle_at_85%_25%,rgba(255,255,255,0.10),transparent_20%),linear-gradient(180deg,#0A2558_0%,#061738_100%)]"
    >
      <div className="absolute -top-40 -left-32 w-[560px] h-[560px] bg-gold/20 rounded-full blur-[140px] animate-aurora-slow pointer-events-none" />
      <div className="absolute bottom-[-180px] right-[-160px] w-[620px] h-[620px] bg-white/10 rounded-full blur-[160px] animate-aurora-medium pointer-events-none" />

      <div className="container-pad relative z-10">
        <div className="rounded-[36px] bg-white/10 backdrop-blur-2xl border border-white/15 shadow-[0_30px_100px_rgba(0,0,0,0.30)] p-8 sm:p-10">
          <div className="grid lg:grid-cols-3 gap-10 items-start">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-2xl bg-gold flex items-center justify-center text-royal shadow-[0_15px_40px_rgba(242,169,0,.35)]">
                  <PawPrint className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-heading text-2xl text-white">Tia Sandra</h3>
                  <p className="text-xs uppercase tracking-[0.2em] text-gold font-bold">Pet Care</p>
                </div>
              </div>

              <p className="text-white/70 leading-relaxed">
                Banho, tosa e higienização com carinho, segurança e atenção em cada detalhe.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-xl text-white mb-4">Contato</h4>

              <div className="space-y-3 text-white/75">
                <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors">
                  <MessageCircle className="w-5 h-5 text-gold" />
                  {SITE.phone}
                </a>

                <a href={SITE.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors">
                  <Instagram className="w-5 h-5 text-gold" />
                  {SITE.instagram}
                </a>

                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-gold" />
                  Ponta Aguda, Blumenau - SC
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xl text-white mb-4">Agendamento</h4>
              <p className="text-white/70 leading-relaxed mb-5">
                Quer deixar seu pet limpinho, cheiroso e bem cuidado?
              </p>

              <a
                href={waLink("Olá! Gostaria de agendar um horário para banho e tosa.")}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-hover text-royal font-bold px-6 py-3 shadow-[0_15px_40px_rgba(242,169,0,.35)] hover:-translate-y-1 transition-all"
              >
                <MessageCircle className="w-5 h-5" />
                Agendar pelo WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-white/45">
          © {new Date().getFullYear()} Tia Sandra Pet Care. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}
